export const DEFAULT_TOUR_SETING = {
  logoURL: null,
  menuHighlightColor: '#F73D3C',
  calloutHeaderColor: '#000000',
  calloutSubHeaderColor: '#FFFFFF',
  lightboxBGColor: '#000000',
  lightboxHeaderColor: '#FFFFFF',
  lightboxBodyTextColor: '#FFFFFF',
};
